import { IMobCellResponse, IMobCellRow } from "@/store/apis/mobsAPI/mobs.types"

export const pickNewerMobRow = (
  cached: IMobCellRow,
  incoming: IMobCellRow
): IMobCellRow => (incoming.version > cached.version ? incoming : cached)

/**
 * The endpoint's `merge`: never mutates `current` (an Immer draft); returns
 * `current` itself when the answer changes nothing, so nothing re-renders.
 */
export const mergeCellSnapshot = (
  current: IMobCellResponse,
  incoming: IMobCellResponse
): IMobCellResponse => {
  const cachedById = new Map(current.mobs.map((row) => [row.id, row]))
  let changed = incoming.mobs.length !== current.mobs.length
  const mobs = incoming.mobs.map((row) => {
    const cached = cachedById.get(row.id)
    const next = cached ? pickNewerMobRow(cached, row) : row
    if (next !== cached) {
      changed = true
    }
    return next
  })
  return changed ? { mobs } : current
}
